/** PRP-04: CarriedInRow.status → badge variant. Extended by PRP-15. */ export const carriedInStatusVariant = {
    mapped: 'success',
    drafted: 'success',
    reused: 'info',
    partially_mapped: 'warning',
    needs_decision: 'warning',
    not_mapped: 'neutral',
    hearsay_not_citable: 'warning'
};
